var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRecent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.84244 8.54789C2.83083 6.7036 3.49079 4.91811 4.69913 3.52474C5.90746 2.13137 7.58158 1.22536 9.40895 0.975844C11.2363 0.726325 13.092 1.15035 14.6297 2.16877C16.1674 3.18719 17.2818 4.73038 17.7651 6.51027C18.2483 8.29016 18.0673 10.1851 17.2559 11.8413C16.4444 13.4975 15.0579 14.8018 13.3553 15.5108C11.6527 16.2197 9.75021 16.2847 8.00312 15.6938C7.06986 15.3781 6.21501 14.8868 5.48045 14.2541",
    stroke: "#747787",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.84263 11.348L5.21577 8.50024H0.469482L2.84263 11.348Z",
    fill: "#747787"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4368 4.70325V9.44953H13.2845",
    stroke: "#747787",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecent);
export default __webpack_public_path__ + "static/media/recent.c9f2d460b5e5054fa61a2ae78be1a680.svg";
export { ForwardRef as ReactComponent };